import { createContext, PropsWithChildren, useContext } from 'react';
import { PurchasePricesUploadedFile } from '../pages/PurchasePrices/PurchasePricesUploader';
import { usePurchasePrices } from './usePurchasePrices';

const PPContext = createContext<{
  PPFiles: PurchasePricesUploadedFile[];
  onSubmitPP: React.FormEventHandler;
  fileToUploadPP: File | undefined;
  onSelectPPFile: (files: File[] | null) => void;
  countPP: number | undefined;
  isLoadingPP: boolean;
  deletePPFileToUpload: () => void;
  onSubmitPPPrevPeriod: React.FormEventHandler;
  isUploadingPP: boolean;
}>({
  PPFiles: [],
  onSubmitPP: () => {},
  fileToUploadPP: undefined,
  deletePPFileToUpload: () => {},
  onSubmitPPPrevPeriod: () => {},
  onSelectPPFile: () => {},
  isUploadingPP: false,
  isLoadingPP: false,
  countPP: undefined,
});

export function PPProvider({ children }: PropsWithChildren<{}>) {
  const {
    uploadedFiles: PPFiles,
    onSubmit: onSubmitPP,
    isUploading: isUploadingPP,
    fileToUpload: fileToUploadPP,
    onSelect: onSelectPPFile,
    count: countPP,
    isLoading: isLoadingPP,
    deleteFileToUpload: deletePPFileToUpload,
    onSubmitPrevPeriod: onSubmitPPPrevPeriod,
  } = usePurchasePrices();

  return (
    <PPContext.Provider
      value={{
        PPFiles,
        onSubmitPP,
        isUploadingPP,
        fileToUploadPP,
        onSelectPPFile,
        countPP,
        isLoadingPP,
        deletePPFileToUpload,
        onSubmitPPPrevPeriod,
      }}
    >
      {children}
    </PPContext.Provider>
  );
}

export const usePP = () => {
  return useContext(PPContext);
};
